/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_SavedInputs */

const cs_templates_saved = /** @type {(inputs: Templates_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona uložena`)
};

const en_templates_saved = /** @type {(inputs: Templates_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template saved`)
};

/**
* | output |
* | --- |
* | "Template saved" |
*
* @param {Templates_SavedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_saved = /** @type {((inputs?: Templates_SavedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_SavedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_saved(inputs)
	return cs_templates_saved(inputs)
});